'use client';

import { SpinnerGapIcon, WarningCircleIcon, TrayIcon } from '@phosphor-icons/react';

/** Centered spinner + label for in-flight loads. */
export function LoadingState({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-white/65">
      <SpinnerGapIcon size={32} className="animate-spin-only" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

/** Friendly error panel; never surfaces raw upstream detail. */
export function ErrorState({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
      <WarningCircleIcon size={36} className="text-[#FF6B5E]" />
      <p className="max-w-md text-sm text-white/70">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="rounded bg-brand-blue px-3 py-1.5 text-sm text-white hover:bg-brand-blue-dark"
        >
          Retry
        </button>
      )}
    </div>
  );
}

/** Empty-state placeholder with an icon + message. */
export function EmptyState({ message }: { message: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-center text-white/50">
      <TrayIcon size={36} />
      <p className="max-w-md text-sm">{message}</p>
    </div>
  );
}

/** Small pill used for enum-ish values (direction, status, role, …). */
export function Badge({ children }: { children: React.ReactNode }) {
  return (
    <span className="inline-flex items-center rounded-full bg-white/10 px-2 py-0.5 text-xs font-medium text-white/80">
      {children}
    </span>
  );
}
